<template>
  <div class="forum">
    <post
      v-for="(post, index) in posts"
      v-bind="post"
      :index="index"
      :key="index"
    ></post>
  </div>
</template>

<script>
import { Post } from "@/components";

var posts = [
  {
    forumPostId: 1,
    postTitle:
      "Er det en igle i dine bukser, eller er du bare glad for at se mig?",
    createdByUserName: "IgleLover69",
    postImage: null,
    comments: [],
    likes: 46,
    dislikes: 3,
    iconHexColor: "#16c20f",
    createdDateTime: "2021/07/03",
  },
  {
    forumPostId: 2,
    postTitle: "Rate min igle!",
    createdByUserName: "Aezzzz",
    postImage: null,
    comments: [1],
    likes: 46,
    dislikes: 3,
    color: "#a7e418",
    createdDateTime: "2021/07/03",
  },
  {
    forumPostId: 3,
    postTitle: "I'm 10 and what is this",
    createdByUserName: "mynameisbilly",
    postImage: null,
    comments: [1, 2, 3],
    likes: 46,
    dislikes: 3,
    iconHexColor: "#cd5ae8",
    createdDateTime: "2021/07/03",
  },
];

export default {
  components: {
    Post,
  },
  data() {
    return {
      posts: [],
    };
  },
  beforeMount() {
    var vm = this;
    this.$store
      .dispatch("api/get", { url: "/1/posts" })
      .then((payload) => {
        vm.posts = payload.data.posts;
      })
      .catch(() => (vm.posts = posts));
  },
};
</script>

<style lang="scss" scoped>
.forum {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 1 auto;
}
</style>
